var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"article-item"},[_c('h1',[_vm._v("#SmartCity: Helsinki 🇫🇮")]),_c('time',{attrs:{"datetime":"2015-10-14T21:04:55.600Z"}},[_vm._v("15 October 2018")]),_c(_vm.bodyComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }